<mat-card>
    <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
        <div ngxSlickItem *ngFor="let slide of advertisment" class="slide">
            <img [src]="slide.image || slides " alt="" max-width="100%" height="100px" class="add-img">
        </div>
    </ngx-slick-carousel>
</mat-card>